/* eslint-disable no-undef */
/* eslint-disable standard/no-callback-literal */
import axios from "axios";
import Moment from "moment";

var http = axios.create({
    baseURL: process.env.API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

http.interceptors.response.use(
    function (response) {
        return response;
    },

    function (error) {
        if (error.response.status !== 401) return Promise.reject(error);

        var refreshAndRetry = new Promise(function (resolve) {
            axios
                .post(
                    process.env.API_BASE_URL + "account/refresh_token",
                    {
                        refresh_token: JSON.parse(
                            localStorage.getItem("refresh_token"),
                        ).value,
                    },
                    {
                        headers: {
                            "Content-Type": "application/json",
                            Authorization:
                                "Bearer " +
                                JSON.parse(localStorage.getItem("token")).value,
                        },
                    },
                )
                .then(function (response) {
                    localStorage.setItem(
                        "refresh_token",
                        JSON.stringify({
                            value: response.data.refresh_token,
                            expire: null,
                        }),
                    );

                    localStorage.setItem(
                        "token",
                        JSON.stringify({
                            value: response.data.token,
                            expire: null,
                        }),
                    );

                    return Promise.resolve(response);
                })
                .then(function (response) {
                    var failedRequest = error.config;
                    failedRequest.headers.Authorization =
                        "Bearer " +
                        JSON.parse(localStorage.getItem("token")).value;
                    axios.request(failedRequest).then(function (retryResponse) {
                        resolve(retryResponse);
                    });
                });
        });

        return refreshAndRetry;
    },
);

function getConfig() {
    return {
        headers: {
            Authorization: JSON.parse(localStorage.getItem("token")).value,
        },
    };
}

function getPembayaranList(pagination, search, callback) {
    var config = getConfig();

    var url = "/transactions?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getPembayaranDetail(id, callback) {
    var config = getConfig();

    http.get("/transactions/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updatePembayaranStatus(id, status, callback) {
    var config = getConfig();
    var param = {
        status: status,
    };

    http.put("/transactions/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getProdukList(pagination, search, callback) {
    var config = getConfig();
    var url = "/products?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getProdukDetail(id, callback) {
    var config = getConfig();

    http.get("/products/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addProduk(data, callback) {
    var config = getConfig();

    http.post("/products", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateProduk(id, data, callback) {
    var config = getConfig();
    var param = {
        type: data.type,
        title: data.title,
        picture: data.picture,
        value: data.value,
        bonus_value: data.bonus_value,
        description: data.description,
        currency: data.currency,
        price: data.price,
        net_price: data.net_price,
        status: data.status,
    };

    http.put("/products/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function uploadProdukPicture(id, formData, callback) {
    var config = getConfig();
    var param = formData;
    config.headers["Content-Type"] = "multipart/form-data";

    http.put("/products/" + id + "/upload_picture", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateAllProdukStatus(status, callback) {
    var config = getConfig();
    var param = {
        status: status,
    };

    http.put("/products/all_product", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteProduk(id, callback) {
    var config = getConfig();

    http.delete("/products/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getMetodePembayaranList(pagination, search, callback) {
    var config = getConfig();

    var url = "/payment_methods?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getMetodePembayaranDetail(id, callback) {
    var config = getConfig();

    http.get("/payment_methods/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addMetodePembayaran(data, callback) {
    var config = getConfig();
    var param = {
        bank_name: data.bank_name,
        bank_code: data.bank_code,
        description: data.description,
        account_number: data.account_number,
        account_name: data.account_name,
        status: data.status,
    };

    http.post("/payment_methods", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateMetodePembayaran(id, data, callback) {
    var config = getConfig();
    var param = {
        bank_name: data.bank_name,
        bank_logo: data.bank_logo,
        bank_code: data.bank_code,
        description: data.description,
        account_number: data.account_number,
        account_name: data.account_name,
        status: data.status,
    };

    http.put("/payment_methods/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function uploadMetodePembayaranBankLogo(id, formData, callback) {
    var config = getConfig();
    var param = formData;
    config.headers["Content-Type"] = "multipart/form-data";

    http.put("/payment_methods/" + id + "/upload_logo", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateAllMetodePembayaranStatus(status, callback) {
    var config = getConfig();
    var param = {
        status: status,
    };

    http.put("/payment_methods/all_methods", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteMetodePembayaran(id, callback) {
    var config = getConfig();

    http.delete("/payment_methods/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTicketUsageList(pagination, search, callback) {
    var config = getConfig();

    var url = "/ticket_usage?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTicketUsageDetail(id, callback) {
    var config = getConfig();

    http.get("/ticket_usage/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getKatalogTiketList(pagination, search, callback) {
    var config = getConfig();

    var url = "/features_activation?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                data: error.response.data,
                message: error.message,
            });
        });
}

function getKatalogTiketDetail(id, callback) {
    var config = getConfig();

    http.get("/features_activation/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addKatalogTiket(data, callback) {
    var config = getConfig();
    var param = {
        type: data.type,
        title: data.title,
        value: data.type === "DUEL" ? 1 : data.value,
        description: data.description,
        ticket: data.ticket,
        status: data.status,
    };

    http.post("/features_activation", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateKatalogTiket(id, data, callback) {
    var config = getConfig();
    var param = {
        type: data.type,
        title: data.title,
        value: data.type === "DUEL" ? 1 : data.value,
        picture: data.picture,
        description: data.description,
        ticket: data.ticket,
        status: data.status,
    };

    http.put("/features_activation/" + id, param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateAllKatalogTiketStatus(status, callback) {
    var config = getConfig();
    var param = {
        status: status,
    };

    http.put("/features_activation/all_feature", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function deleteKatalogTiket(id, callback) {
    var config = getConfig();

    http.delete("/features_activation/" + id, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function uploadKatalogTiketPicture(id, formData, callback) {
    var config = getConfig();
    var param = formData;
    config.headers["Content-Type"] = "multipart/form-data";

    http.put("/features_activation/" + id + "/upload_picture", param, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createPaket(data, callback) {
    var config = getConfig();
    if (data.package_category === "PACKAGES") {
        data.start_date = Moment(data.start_date).valueOf();
        data.expiry_date = Moment(data.expiry_date).valueOf();
    } else {
        data.start_date = 0;
        data.expiry_date = 0;
    }
    http.post("payment/package/createpackage", data, config)
        .then(function (response) {
            if (response.data.status === "200") {
                callback({
                    success: true,
                    data: response.data,
                });
            } else {
                callback({
                    success: false,
                    message: response.data,
                });
            }
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getPaket(callback) {
    var config = getConfig();
    http.get("payment/package/getallpackage", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailPaket(data, callback) {
    var config = getConfig();
    http.get("payment/package/getpackagedetail/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updatePaket(id, data, callback) {
    var config = getConfig();
    if (data.package_category === "PACKAGES") {
        data.start_date = Moment(data.start_date).valueOf();
        data.expiry_date = Moment(data.expiry_date).valueOf();
    } else {
        data.start_date = 0;
        data.expiry_date = 0;
    }
    http.put("payment/package/updatepackage/" + id, data, config)
        .then(function (response) {
            if (response.data.status === "200") {
                callback({
                    success: true,
                    data: response.data,
                });
            } else {
                callback({
                    success: false,
                    message: response.data,
                });
            }
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function hapusPaket(data, callback) {
    var config = getConfig();
    http.delete("payment/package/deletepackage/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getPackageByUserGroup(data, callback) {
    var config = getConfig();
    http.get("payment/list/packages/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
                total_data: response.total_data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getContentByUserGroup(data, callback) {
    var config = getConfig();
    http.get("payment/list/contents/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListUserGroup(callback) {
    var config = getConfig();
    http.get("payment/list/user_group?page=1&per_page=1000", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
                total_data: response.total_data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailUserGroup(data, callback) {
    var config = getConfig();
    http.get("payment/user_group/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function addUserGroup(data, callback) {
    var config = getConfig();
    http.post("payment/user_group/create", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateUserGroup(id, dataBody, callback) {
    var config = getConfig();
    http.put("/payment/user_group/update/" + id, dataBody, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getListAppScope(callback) {
    var config = getConfig();
    http.get("payment/packages/app_scopes", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createJadwalKelas(data, callback) {
    var config = getConfig();
    http.post("payment/package/group/create", data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateJadwalKelas(id, data, callback) {
    var config = getConfig();

    http.put(`payment/package/group/${id}/update`, data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getListJadwalKelas(callback) {
    var config = getConfig();
    await http
        .get("payment/package/group/getall", config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getMembersKelas(id, params, callback) {
    var config = getConfig();
    await http
        .get(
            `payment/package/group/${id}/members/detail?name=${params.search}&page=${params.page}&size=${params.size}`,
            config,
        )
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailJadwal(id, callback) {
    var config = getConfig();
    http.get(`payment/package/group/${id}/detail`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getListTransaksi(params, callback) {
    var config = getConfig();
    await http
        .get(`payment/transaction/admin/getlist/transaction`, {
            params: {
                page: params.page,
                per_page: params.perPage,
                order_id: params.order_id,
                email: params.email,
                sort: params.sortMode,
                student_name: params.nama_siswa,
                package_name: params.package_name,
                group_name: params.group_name,
                phone_number: params.handphone,
                package: params.paket,
                group: params.group,
                nominal: params.nominal,
                transaction_status: params.status,
                transaction_payment_time: params.transaction_payment_time,
                price: params.price,
                payment_company: params.payment_company,
                date_from: params.start_date,
                date_to: params.end_date,
            },
            headers: config.headers,
        })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getDetailTransaksi(id, callback) {
    var config = getConfig();
    await http
        .get(`payment/transaction/admin/${id}/detail/transaction`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getListReferralCode(params, callback) {
    var config = getConfig();
    await http
        .get(`payment/admin/referral_code`, {
            params: {
                email: params.email,
                referral_code: params.referral_code,
                school: params.school,
                page: params.page,
                per_page: params.per_page,
            },
            headers: config.headers,
        })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function exportReferralCodeList(params, callback) {
    await http
        .get(`payment/admin/referral_code/export_excel/`, {
            params: {
                start_date: params.start_date,
                end_date: params.end_date,
            },
            responseType: "arraybuffer",
            headers: {
                Authorization: JSON.parse(localStorage.getItem("token")).value,
                Accept: "application/octet-stream",
            },
        })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function detailReferralCode(id, callback) {
    var config = getConfig();
    await http
        .get(`payment/admin/referral_code/${id}`, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

async function getListReferralUsage(param, callback) {
    var config = getConfig();
    await http
        .get(`payment/admin/referral_code/referral_usage`, {
            params: {
                email: param.email,
                order_id: param.order_id,
                usage_date: param.usage_date,
                package_group: param.package_group,
                school: param.school,
                referral_code: param.referral_code,
                page: param.page,
                per_page: param.per_page,
            },
            headers: config.headers,
        })
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getTestimoni(pagination, search, callback) {
    var config = getConfig();
    var url = "/payment/testimoni/admin/list?";

    if (pagination.perPage !== undefined && pagination.perPage !== null)
        url += "per_page=" + pagination.perPage;
    if (pagination.currentPage !== undefined && pagination.currentPage !== null)
        url += "&page=" + pagination.currentPage;
    if (pagination.sortMode !== undefined && pagination.sortMode !== null) {
        url += "&sort_mode=" + pagination.sortMode.toUpperCase();
    }
    if (search && search.query && search.by)
        url += "&search=" + search.query + "&search_by=" + search.by;

    http.get(url, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailTestimoni(data, callback) {
    var config = getConfig();
    http.get("payment/testimoni?id=" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function getDetailUserTransaction(data, callback) {
    var config = getConfig();
    http.get("payment/testimoni/user/transaction-history?email=" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function createTestimoni(data, callback) {
    var config = getConfig();
    http.post("payment/testimoni", data, config)
        .then(function (response) {
            if (response.data.status === "200") {
                callback({
                    success: true,
                    data: response.data,
                });
            } else {
                callback({
                    success: false,
                    message: response.data,
                });
            }
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function updateTestimoni(id, data, callback) {
    var config = getConfig();
    http.put("payment/testimoni/" + id, data, config)
        .then(function (response) {
            if (response.data.status === "200") {
                callback({
                    success: true,
                    data: response.data,
                });
            } else {
                callback({
                    success: false,
                    message: response.data,
                });
            }
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

function hapusTestimoni(data, callback) {
    var config = getConfig();
    http.delete("payment/testimoni/" + data, config)
        .then(function (response) {
            callback({
                success: true,
                data: response.data,
            });
        })
        .catch(function (error) {
            callback({
                success: false,
                message: error.message,
            });
        });
}

export default {
    getPembayaranList,
    getPembayaranDetail,
    updatePembayaranStatus,
    getProdukList,
    getProdukDetail,
    addProduk,
    uploadProdukPicture,
    updateProduk,
    updateAllProdukStatus,
    deleteProduk,
    getMetodePembayaranList,
    getMetodePembayaranDetail,
    addMetodePembayaran,
    updateMetodePembayaran,
    uploadMetodePembayaranBankLogo,
    updateAllMetodePembayaranStatus,
    deleteMetodePembayaran,
    getTicketUsageList,
    getTicketUsageDetail,
    getKatalogTiketList,
    getKatalogTiketDetail,
    addKatalogTiket,
    updateKatalogTiket,
    updateAllKatalogTiketStatus,
    uploadKatalogTiketPicture,
    deleteKatalogTiket,
    createPaket,
    getPaket,
    getDetailPaket,
    updatePaket,
    hapusPaket,
    getListJadwalKelas,
    getDetailJadwal,
    getMembersKelas,
    getPackageByUserGroup,
    getContentByUserGroup,
    getListUserGroup,
    getDetailUserGroup,
    addUserGroup,
    updateUserGroup,
    getListAppScope,
    createJadwalKelas,
    updateJadwalKelas,
    getListTransaksi,
    getDetailTransaksi,
    getListReferralCode,
    exportReferralCodeList,
    detailReferralCode,
    getListReferralUsage,
    getTestimoni,
    getDetailTestimoni,
    getDetailUserTransaction,
    createTestimoni,
    updateTestimoni,
    hapusTestimoni,
};



// WEBPACK FOOTER //
// ./src/modules/global/services/sales.js